import React, { useEffect, useState } from "react";
import "./provider.css";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ProviderService, {
  getSingleProvider,
} from "../../services/providerService";
import { formiksignup } from "./validation";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { countries } from "countries-list";
import { Autocomplete, TextField } from "@mui/material";
import BackButton from "../../../utils/BackButton";
import DatePicker from "react-datepicker";
import { format, parse } from "date-fns";

function ProviderComponent() {
  const navigate = useNavigate();
  const location = useLocation();
  const { provider } = location.state || {};
  const userdata = useSelector((state) => state);
  let adminRole = userdata?.login?.data?.role;
  const [selectedFile, setSelectedFile] = useState(null);
  const [ferchedProvider, setFetchedProvider] = useState({});
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isValidInviteCode, setIsValidInviteCode] = useState(true);
  const formik = useFormik({
    ...formiksignup,
    onSubmit: async (values, { setSubmitting }) => {
      // Check if invite code is valid before proceeding
      if (formik.values.invideCode.length === 6 && !isValidInviteCode) {
        formik.setTouched({
          invideCode: true,
        })
        toast.error("Please enter a valid invite code.");
        return;
      }
      try {
        // Create FormData object for file upload
        const formData = new FormData();
        formData.append("firstName", values.firstName);
        formData.append("lastName", values.lastName);
        formData.append("email", values.email);
        formData.append("primaryPhone", values.primaryPhone);
        formData.append("gender", values.gender);
        // Convert dd/MM/yyyy to YYYY-MM-DD (ISO format) for backend
        let dobForBackend = values.dob;
        if (values.dob) {
          try {
            const parsedDate = parse(values.dob, "dd/MM/yyyy", new Date());
            if (!isNaN(parsedDate.getTime())) {
              dobForBackend = format(parsedDate, "yyyy-MM-dd");
            }
          } catch (error) {
          }
        }
        formData.append("dob", dobForBackend);
        formData.append("countyrOpractice", values.countyrOpractice);
        formData.append("medicalSetting", values.medicalSetting);
        formData.append("medicalSpeciality", values.medicalSpeciality);
        formData.append("profilePhoto", selectedFile || "");
        formData.append("role", values?.role || "DOCTOR");
        formData.append("about", values.about);
        formData.append("invideCode", values.invideCode);


        let res;
        if (provider) {
          res = await ProviderService.editDoctor(formData, provider);
        } else {
          res = await ProviderService.registration(formData);
        }
        if (res.status === "SUCCESS") {
          toast.success(res.message);
          adminRole == "ADMIN" && navigate(-1);
          adminRole == "DOCTOR" &&
            navigate(`/doctor/profile`, {
              state: { provider: ferchedProvider },
            });
        } else {
          toast.error(res.message);
        }
      } catch (error) {
        toast.error("Failed!");
      }
    },
  });

  const checkProviderDetails = async () => {
    const data = await getSingleProvider(provider);
    if (data) {
      setFetchedProvider(data);
      // Convert ISO date (YYYY-MM-DD) to dd/MM/yyyy format for DatePicker
      let dobFormatted = "";
      if (data.dob) {
        try {
          const isoDate = data.dob.split("T")[0]; // Get YYYY-MM-DD
          const dateParts = isoDate.split("-");
          if (dateParts.length === 3) {
            // Convert YYYY-MM-DD to dd/MM/yyyy
            dobFormatted = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
          }
        } catch (error) {
          dobFormatted = "";
        }
      }
      formik.setValues({
        firstName: data.firstName || "",
        lastName: data.lastName || "",
        email: data.email || "",
        primaryPhone: data.primaryPhone || "",
        gender: data.gender || "",
        dob: dobFormatted,
        countyrOpractice: data.countyrOpractice || "",
        medicalSetting: data.medicalSetting || "",
        medicalSpeciality: data.medicalSpeciality || "",
        profilePhoto: data.profilePhoto || "",
        about: data.about || "",
        role: data?.role || "DOCTOR",
        invideCode: data?.invideCode || "",
      });
      if (data.profilePhotoUrl) {
        setPreviewUrl(data.profilePhotoUrl);
      }
      if (data.gender) {
        formik.setFieldValue("gender", data.gender || "");
      }
    }
  };

  // CHECK INVITE CODE
  const checkInviteCode = async (code) => {
    try {
      const response = await ProviderService.checkInviteCode(code, provider);
      if (response.exists) {
        // formik.setFieldValue("invideCode", "");
        toast.error("Invite code is Already used");

        formik.setFieldError("invideCode", "Invite code is Already used");
        setIsValidInviteCode(false);
      } else {
        toast.success("Invite code is available");
        setIsValidInviteCode(true);
      }


    } catch (error) {
      toast.error("Failed to check invite code");
    }
    formik.setFieldTouched("invideCode", true);
  };

  useEffect(() => {
    checkProviderDetails();
  }, [provider]);

  return (
    <div className="Dashboard-wrapper provider-form-page">
      {/* doctor-page */}
      <BackButton className="" />

      <div className="dashboard-insights mt-2">
        <Form className="form-block" onSubmit={formik.handleSubmit}>
          <div className="doctor-box">
            <Form.Group className="mb-3" controlId="formProfilePhoto">
              <div className="image-upload"></div>
            </Form.Group>

            <div className="forms-box">
              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInputFirstName"
                >
                  <Form.Label className="details">
                    First Name<span className="asterisk">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter first name"
                    name="firstName"
                    keyField={"firstName"}
                    formik={formik}
                    value={formik.values.firstName}
                    onChange={(e) =>
                      formik.setFieldValue("firstName", e.target.value)
                    }
                    onBlur={formik.handleBlur}
                    isInvalid={
                      formik.touched.firstName && !!formik.errors.firstName
                    }
                  />
                  {formik.touched.firstName && formik.errors.firstName ? (
                    <div className="text-danger">{formik.errors.firstName}</div>
                  ) : null}
                </Form.Group>
              </div>

              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInputLastName"
                >
                  <Form.Label className="details">
                    Last Name<span className="asterisk">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter last name"
                    name="lastName"
                    keyField={"lastName"}
                    formik={formik}
                    value={formik.values.lastName}
                    onChange={(e) =>
                      formik.setFieldValue("lastName", e.target.value)
                    }
                    onBlur={formik.handleBlur}
                    isInvalid={
                      formik.touched.lastName && !!formik.errors.lastName
                    }
                  />
                  {formik.touched.lastName && formik.errors.lastName ? (
                    <div className="text-danger">{formik.errors.lastName}</div>
                  ) : null}
                </Form.Group>
              </div>

              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInputMobile"
                >
                  <Form.Label className="details">
                    Mobile Number<span className="asterisk">*</span>
                  </Form.Label>
                  <Form.Control
                    type="tel"
                    placeholder="Enter Mobile No."
                    name="primaryPhone"
                    keyField={"primaryPhone"}
                    formik={formik}
                    value={formik.values.primaryPhone}
                    onChange={(e) =>
                      formik.setFieldValue("primaryPhone", e.target.value)
                    }
                    onBlur={formik.handleBlur}
                    isInvalid={
                      formik.touched.primaryPhone &&
                      !!formik.errors.primaryPhone
                    }
                  />

                  {formik.touched.primaryPhone && formik.errors.primaryPhone ? (
                    <div className="text-danger">
                      {formik.errors.primaryPhone}
                    </div>
                  ) : null}
                </Form.Group>
              </div>

              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInputEmail"
                >
                  <Form.Label className="details">
                    Email<span className="asterisk">*</span>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="name@example.com"
                    name="email"
                    keyField={"email"}
                    formik={formik}
                    value={formik.values.email}
                    onChange={(e) =>
                      formik.setFieldValue("email", e.target.value)
                    }
                    onBlur={formik.handleBlur}
                    isInvalid={formik.touched.email && !!formik.errors.email}
                  />
                  {formik.touched.email && formik.errors.email ? (
                    <div className="text-danger">{formik.errors.email}</div>
                  ) : null}
                </Form.Group>
              </div>

              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlSelectGender"
                >
                  <Form.Label className="details">
                    Gender <span className="asterisk">*</span>
                  </Form.Label>
                  <Form.Select
                    className="selected-fields"
                    name="gender"
                    value={formik.values.gender}
                    onChange={(e) => formik.setFieldValue("gender", e.target.value)}
                    onBlur={formik.handleBlur}
                    isInvalid={formik.touched.gender && !!formik.errors.gender}
                    required
                  >
                    <option value="" disabled className="placeholder-option">
                      Select Gender
                    </option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </Form.Select>



                  {/* {formik.touched.gender && formik.errors.gender ? (
                    <div className="text-danger">{formik.errors.gender}</div>
                  ) : null} */}
                </Form.Group>
              </div>


              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInputDOB"
                >
                  <Form.Label className="details">
                    Date of Birth <span className="asterisk">*</span>
                  </Form.Label>
                  {/* <Form.Control
                    type="date"
                    placeholder="Select date of birth"
                    name="dob"
                    keyField={"dob"}
                    formik={formik}
                    value={formik.values.dob}
                    onChange={(e) =>
                      formik.setFieldValue("dob", e.target.value)
                    }
                    onBlur={formik.handleBlur}
                    isInvalid={formik.touched.dob && !!formik.errors.dob}
                  /> */}
                  <DatePicker
                    selected={
                      formik.values.dob
                        ? (() => {
                          try {
                            const parsed = parse(formik.values.dob, "dd/MM/yyyy", new Date());
                            // Check if parsed date is valid
                            if (isNaN(parsed.getTime())) {
                              return null;
                            }
                            return parsed;
                          } catch (error) {
                            return null;
                          }
                        })()
                        : null
                    }
                    onChange={(date) => {
                      const formatted = date ? format(date, "dd/MM/yyyy") : "";
                      formik.setFieldValue("dob", formatted);  // store as dd/MM/yyyy
                    }}
                    onBlur={formik.handleBlur}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="dd/mm/yyyy"
                    className={`form-control ${formik.touched.dob && formik.errors.dob ? "is-invalid" : ""
                      }`}
                    wrapperClassName="w-100"
                  />
                  {formik.touched.dob && formik.errors.dob ? (
                    <div className="text-danger">{formik.errors.dob}</div>
                  ) : null}
                </Form.Group>
              </div>

              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlCountryPractice"
                >
                  <Form.Label className="details">
                    Country of Practice{" "}
                  </Form.Label>
                  <Autocomplete
                    id="country-practice-autocomplete"
                    options={Object.values(countries).map(
                      (country) => country.name
                    )} // Getting the country names
                    onChange={(event, value) => {
                      formik.setFieldValue("countyrOpractice", value);
                    }}
                    value={formik.values.countyrOpractice || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label=""
                        variant="outlined"
                        error={
                          formik.touched.countyrOpractice &&
                          Boolean(formik.errors.countyrOpractice)
                        }
                        helperText={
                          formik.touched.countyrOpractice &&
                          formik.errors.countyrOpractice
                        }
                      />
                    )}
                  />
                </Form.Group>
              </div>

              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlSelectNationality"
                >
                  <Form.Label className="details">Medical Setting </Form.Label>
                  {/* <Form.Select
                    className="selected-fields"
                    name="medicalSetting"
                    keyField={"medicalSetting"}
                    formik={formik}
                    value={formik.values.medicalSetting}
                    onChange={(e) =>
                      formik.setFieldValue("medicalSetting", e.target.value)
                    }
                    onBlur={formik.handleBlur}
                    isInvalid={
                      formik.touched.medicalSetting &&
                      !!formik.errors.medicalSetting
                    }
                  >
                    <option>Select Setting</option>
                    <option value="Hospital">Hospital</option>
                    <option value="Private Practice">Private Practice</option>
                    <option value="Clinic">Clinic</option>
                    <option value="Academic Medical Center">
                      Academic Medical Center
                    </option>
                    <option value="Other">Other</option>
                  </Form.Select> */}
                  <Autocomplete
                    id="medical-setting-autocomplete"
                    options={[
                      "Hospital",
                      "Private Practice",
                      "Clinic",
                      "Academic Medical Center",
                      "Other",
                      "General Practitioner",
                      "Family Medicine",
                      "Cardiology",
                      "Neurology",
                      "Orthopedics",
                      "Pediatrics",
                      "Gastroenterology",
                      "Rheumatology",
                      "Dermatology",
                      "Endocrinology",
                      "Psychiatry",
                      "Oncology",
                      "Urology",
                      "Gynecology",
                      "Ophthalmology",
                      "Pulmonary",
                      "Neurosurgery",
                      "Orthopedics",
                      "Pediatrics",
                      "Gastroenterology",
                      "Rheumatology",
                      "Dermatology",
                      "Endocrinology",
                    ]} // Medical setting options
                    onChange={(event, value) => {
                      formik.setFieldValue("medicalSetting", value);
                    }}
                    value={formik.values.medicalSetting || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label=""
                        variant="outlined"
                        error={
                          formik.touched.medicalSetting &&
                          Boolean(formik.errors.medicalSetting)
                        }
                        helperText={
                          formik.touched.medicalSetting &&
                          formik.errors.medicalSetting
                        }
                      />
                    )}
                  />
                </Form.Group>
              </div>

              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlSelectNationality"
                >
                  <Form.Label className="details">
                    Medical Speciality{" "}
                  </Form.Label>
                  {/* <Form.Select
                    className="selected-fields"
                    name="medicalSpeciality"
                    keyField={"medicalSpeciality"}
                    formik={formik}
                    value={formik.values.medicalSpeciality}
                    onChange={(e) =>
                      formik.setFieldValue("medicalSpeciality", e.target.value)
                    }
                    onBlur={formik.handleBlur}
                    isInvalid={
                      formik.touched.medicalSpeciality &&
                      !!formik.errors.medicalSpeciality
                    }
                  >
                    <option>Select Speciality</option>
                    <option value="cardiology">Cardiology</option>
                    <option value="neurology">Neurology</option>
                    <option value="orthopedics">Orthopedics</option>
                    <option value="other">Other</option>
                  </Form.Select> */}
                  <Autocomplete
                    id="medical-speciality-autocomplete"
                    options={[
                      "Cardiology",
                      "Neurology",
                      "Orthopedics",
                      "Surgery",
                      "Pediatrics",
                      "Gastroenterology",
                      "Urology",
                      "Oncology",
                      "Rheumatology",
                      "Dermatology",
                      "Psychiatry",
                      "Ophthalmology",
                      "Gynecology",
                      "Endocrinology",
                      "Psychology",
                      "Dermatology",
                      "Nephrology",
                      "Hematology",
                      "Immunology",
                      "Pediatrics",
                      "Otorhinolaryngology",
                      "Urology",
                      "General Medicine",
                      "Anesthesiology",
                      "Cardiology",
                      "Pulmonary Medicine",
                      "Neurology",
                      "Orthopedics",
                    ]} // Medical speciality options
                    onChange={(event, value) => {
                      formik.setFieldValue("medicalSpeciality", value);
                    }}
                    value={formik.values.medicalSpeciality || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label=""
                        variant="outlined"
                        error={
                          formik.touched.medicalSpeciality &&
                          Boolean(formik.errors.medicalSpeciality)
                        }
                        helperText={
                          formik.touched.medicalSpeciality &&
                          formik.errors.medicalSpeciality
                        }
                      />
                    )}
                  />
                </Form.Group>
              </div>
              {/* Invite Code */}
              <div className="form-control-area w-100">
                <Form.Group
                  className="mb-3 w-100"
                  controlId="exampleForm.ControlInputFirstName "
                >
                  <Form.Label className="details">
                    Invite Code <span className="asterisk"></span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter 6 digit invite code"
                    name="invideCode"
                    maxLength={6}
                    keyField={"invideCode"}
                    formik={formik}
                    value={formik.values.invideCode}
                    onChange={(e) => {
                      formik.setFieldValue("invideCode", e.target.value)
                      if (e.target.value.length == 6) {
                        checkInviteCode(e.target.value)
                      }
                    }
                    }
                    onBlur={formik.handleBlur}
                    isInvalid={formik.touched.invideCode && !!formik.errors.invideCode}
                  />
                  {formik.touched.invideCode && formik.errors.invideCode ? (
                    <div className="text-danger">{formik.errors.invideCode}</div>
                  ) : null}
                  {
                    (isValidInviteCode && formik.values.invideCode?.length == 6) && (
                      <div className="text-success">Invite code is available</div>
                    )}
                  {
                    !isValidInviteCode && formik.values.invideCode.length == 6 && (
                      <div className="text-danger">Invite code is not available</div>
                    )}

                </Form.Group>
              </div>
              {/* ABout doctor  */}
              <div className="form-control-area">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInputFirstName"
                >
                  <Form.Label className="details">
                    About Doctor <span className="asterisk"></span>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    placeholder="Enter About Doctor"
                    name="about"
                    keyField={"about"}
                    formik={formik}
                    value={formik.values.about}
                    onChange={(e) =>
                      formik.setFieldValue("about", e.target.value)
                    }
                    onBlur={formik.handleBlur}
                    isInvalid={formik.touched.about && !!formik.errors.about}
                  />
                  {formik.touched.about && formik.errors.about ? (
                    <div className="text-danger">{formik.errors.about}</div>
                  ) : null}
                </Form.Group>
              </div>
            </div>
          </div>
          <div className="button-block">
            <Button className="outlined-btn" onClick={() => navigate(-1)}>
              Cancel
            </Button>

            <Button
              type="submit"
              className="filled-btn"
              disabled={formik.isSubmitting}
            >
              {formik.isSubmitting ? "Please Wait ..." : "Save"}
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
}
export default ProviderComponent;
